'use strict';

function resizeWindow() {
	equalize();
}
function scrollDown() {
	var top = $(document).scrollTop();
	if (top > 20) {
		$('#header').addClass('scroll', 200);
	} else {
		$('#header').removeClass('scroll', 200);
	}
}

$(document).ready(function () {

	//Slick Slider
	$('.sym-slides').slick();

	$('.tabs-qlife').click(function () {
		var $this = $(this);
		$('.pillars-content-ss a').removeClass('active-tabs-qlife');
		$this.addClass('active-tabs-qlife');
		$.get(site_url + '/ajax/functions.php', {
			operation: "getPostQlife",
			id_blog: $this.data('id'),
			language: language_code
		}).done(function (data) {
			$("#container-post").html(data).fadeIn(600);
			initSlider();
		});
	});

	if ($('.container-pillars a.box-1.tabs-qlife').length > 0) {
		$('.container-pillars a.box-1.tabs-qlife').trigger("click");
		$('.next-qlife').trigger("click");
	}

	$('.prev-qlife, .next-qlife').click(function () {
		var active_tab = $("a.active-tabs-qlife"),
		    action = $(this).data('page'),
		    target;

		target = action === "prev" ? active_tab.prev(".tabs-qlife") : active_tab.next(".tabs-qlife");

		if (target.length === 0) {
			console.log("last or first!");
			target = action === 'prev' ? $("a.tabs-qlife").last() : $("a.tabs-qlife").first();
		}

		console.log(target);
		target.click();
	});

	function initSlider() {
		$('#container-post .slick').slick({
			arrows: true,
			dots: false,
			autoplay: false,
			autoplaySpeed: 4000,
			accessibility: false,
			adaptiveHeight: true,
			fade: true,
			infinite: true
		});
		setTimeout(function () {
			equalize({ reset: true });
			$('.next-qlife').fadeIn();
			$('.prev-qlife').fadeIn();
		}, 500);
	}

	//Call function with browser is resized.
	$(window).resize(function (event) {
		resizeWindow();
	});

	//Acts when scroll down page.
	$(window).scroll(function (event) {
		scrollDown();
	});

	// Main Nav Dropdown
	$("#primary-nav li").hover(function () {

		$(this).addClass("hover");
		$('ul.submenu', this).fadeIn(200);
	}, function () {

		$(this).removeClass("hover");
		$('ul.submenu', this).fadeOut(200);
	});

	/*** tablet nav ***/
	$('.menu-trigger').click(function () {
		if ($(this).hasClass('open')) {
			$('#header .tablet-primary').fadeOut();
			var text = $(this).text();
			$('.menu-text').text('Menu');
			$('.menu-holder').addClass('close');
			$('#header .menu-holder .menu-text').removeClass('scroll');
		} else {
			$('#header .tablet-primary').fadeIn();
			var text = $(this).text();
			$('.menu-text').text('Close');
			$('#header .menu-holder .menu-text').removeClass('scroll');
			$('.menu-holder').removeClass('close');
			if ($('.navigation ul li a').hasClass('active')) {
				$(".item-open").get(0);
			}
		}
	});
	$('.menu-trigger').click(function () {
		$(this).toggleClass('open');
	});

	$('.all-golf-imgs').slick({
		centerMode: true,
		centerPadding: '0px',
		slidesToShow: 3,
		arrows: true,
		accessibility: false
	});

	//Full desktop subnav
	$('#header #primary-nav ul li').wrapInner('<span class="forced-sub"></span>');

	//SUBNAVIGATION
	// Open active sub-nav on load
	$('.navigation ul.submenu li .active').parents().parents('li').addClass('item-open');
	$('.navigation ul.submenu li .active').closest('.sub-sub-menu').slideDown(300, 'easeOutQuart', function () {}).addClass('menu-open');

	//Toggle open/close on tap
	$('.navigation li a').off('click').on('click', function (event) {
		if ($(this).parent().children(".sub-sub-menu").length > 0) {

			event.preventDefault();

			if ($(this).next().hasClass('menu-open')) {
				$(this).parent().parent().removeClass('open');
				$(this).parent().removeClass('item-open');
				$(this).next().slideUp(300, 'easeOutQuart').removeClass('menu-open');
				console.log("close");
			} else {
				$(this).parent().parent().addClass('open');
				$(this).parent().addClass('item-open');
				$('.sub-sub-menu.menu-open').slideUp(300, 'easeOutQuart').removeClass('menu-open');
				$(this).next().slideDown(300, 'easeOutQuart', function () {}).addClass('menu-open');
				console.log("open");
			}
		}
	});
	// Navigation Available Max-Height
	var topSiblings = $('.navigation .inner').prevAll().outerHeight() + 20; // Add 20px padding-top
	var bottomSiblings = $('.navigation .inner').nextAll().height();
	var viewportHeight = $(window).height() * 0.95; // Substract 5% for top buttons

	var navigationHeight = viewportHeight - (bottomSiblings + topSiblings);
	$('.navigation .inner > ul').css("max-height", navigationHeight);
	// Remove the mobile redirect on tablet nav
	$(".tablet-primary .navigation .inner li a").each(function () {
		this.href = this.href.replace('/m/', '/');
	});
	/*** end tablet nav ***/

	//Home page scroll down arrow. If present.
	$('.arrow-home').click(function (event) {
		$('body, html').animate({
			scrollTop: $(window).height() - $('header').outerHeight() }, 800, 'easeOutExpo');
	});

	$('.prop-slides').slick({
		arrows: true,
		dots: true,
		autoplay: false,
		autoplaySpeed: 4000,
		speed: 500,
		fade: true,
		accessibility: false,
		prevArrow: $('.prev-gallery-prop'),
		nextArrow: $('.next-gallery-prop'),
		appendDots: $('.amenities-nav-prop'),
		customPaging: function customPaging(slider, i) {
			var thumb = $(slider.$slides[i]).data();
			return '0' + (i + 1);
		}
	});

	$('.exclusives-home').slick({
		arrows: false,
		dots: true,
		autoplay: false,
		autoplaySpeed: 4000,
		speed: 500,
		fade: true,
		accessibility: false,
		appendDots: $('.exclusive-nav'),
		customPaging: function customPaging(slider, i) {
			var title = $(slider.$slides[i]).data('title');
			return '<a>' + title + '</a>';
		}
	});

	$('.privileges').slick({
		arrows: false,
		dots: true,
		autoplay: false,
		autoplaySpeed: 4000,
		speed: 500,
		fade: true,
		accessibility: false,
		adaptiveHeight: true,
		appendDots: $('.privileges-nav'),
		customPaging: function customPaging(slider, i) {
			var title = $(slider.$slides[i]).data('title');
			return '<a>' + title + '</a>';
		}
	});

	$(".tabs-menu a").click(function (event) {
		event.preventDefault();
		$('.tabs-menu a').removeClass("active");
		$(this).addClass("active");
		var tab = $(this).attr("href");
		$(".tab-content").not(tab).css("display", "none");
		$(tab).fadeIn();
		$('.prop-slides').slick('unslick');
		$('.prop-slides').slick({
			arrows: true,
			dots: true,
			autoplay: false,
			autoplaySpeed: 4000,
			speed: 500,
			fade: true,
			accessibility: false,
			prevArrow: $('.prev-gallery-prop'),
			nextArrow: $('.next-gallery-prop'),
			appendDots: $('.amenities-nav-prop'),
			customPaging: function customPaging(slider, i) {
				var thumb = $(slider.$slides[i]).data();
				return '0' + (i + 1);
			}
		});
	});

	//Event Tracking
	$('.book-now').on('click', function () {
		ga('send', 'event', 'reservations', 'click', 'book now');
	});
	$('.bookNow').on('click', function () {
		ga('send', 'event', 'header widget', 'click', 'book now');
	});

	//Map: Return to previous page button. Change body id to match map template's name.
	$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

	if ($('.sitemap').length > 0) {
		list = $("ul.global-sitemap");
		listItems = list.find("> li");
		listItems.each(function (index) {
			var itemTop = $(this).position().top;
			if (itemTop > list.height() / 2) {
				listHalf = index;
				return false;
			}
		});
		listItems.slice(0, listHalf).wrapAll("<div class='col-sm-6'/></div>");
		listItems.slice(listHalf, listItems.length).wrapAll("<div class='col-sm-6'/></div>");
		list.addClass("row");
	}

	$(".vimeo").fancybox({
		width: '100%',
		height: '100%',
		type: 'iframe',
		fitToView: false
	});

	// Facebook share button
	(function (d, s, id) {
		var js,
		    fjs = d.getElementsByTagName(s)[0];
		if (d.getElementById(id)) return;
		js = d.createElement(s);js.id = id;
		js.src = 'https://connect.facebook.net/es_ES/sdk.js#xfbml=1&version=v3.0';
		fjs.parentNode.insertBefore(js, fjs);
	})(document, 'script', 'facebook-jssdk');

	// Youtube Channel

	var channelID = "UC2t1BXvsV_att_e2wrEomPw";
	$.getJSON('https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fwww.youtube.com%2Ffeeds%2Fvideos.xml%3Fchannel_id%3D' + channelID, function (data) {
		var channel_link_1 = data.items[1].link;
		var video_id_1 = channel_link_1.substr(channel_link_1.indexOf("=") + 1);
		$("#youtube_video_1").attr("src", "https://youtube.com/embed/" + video_id_1 + "?controls=0&showinfo=0&rel=0");

		var channel_link_2 = data.items[2].link;
		var video_id_2 = channel_link_2.substr(channel_link_2.indexOf("=") + 1);
		$("#youtube_video_2").attr("src", "https://youtube.com/embed/" + video_id_2 + "?controls=0&showinfo=0&rel=0");

		var channel_link_3 = data.items[3].link;
		var video_id_3 = channel_link_3.substr(channel_link_3.indexOf("=") + 1);
		$("#youtube_video_3").attr("src", "https://youtube.com/embed/" + video_id_3 + "?controls=0&showinfo=0&rel=0");
	});
});

$(".vidOpener").fancybox({
	maxWidth: '100%',
	maxHeight: '100%',
	padding: 0,
	afterShow: function afterShow() {
		this.content.find('video').trigger('play');
	},
	beforeShow: function beforeShow() {
		this.content.find('video').trigger('stop');
	}
});

// var fancyboxModule = (function($, undefined) {
// 	var videoID = [];
// 	indexVid = function() {
// 		for (i = 1; i <= 3; i++) {
// 			var vidOpener = $("#video"+[i]),
// 				videoTag = vidOpener.children(".videoTag").html(),
// 				video;
// 			if (vidOpener.length) {
// 				vidOpener.fancybox({
// 					content: videoTag,
// 					padding:0,
// 					wrapCSS : 'video-lightbox-class',
// 				    helpers: {
// 				        overlay : {
// 				            locked : false,
// 				            css : {
// 				                'background' : 'rgba(0, 0, 0, 0.8)',
// 				                'width'         : '100%',
// 								'height'        : '100%',
// 				            }
// 				        }
// 				    },
// 				    beforeShow: function() {
// 				    	video = $('.fancyboxVid').find("video").get(0);
// 				    	video.load();
// 				    	video.play();
// 				    }
// 				});
// 			}
// 		}
// 	};
// 	return {
// 		init: indexVid()
// 	}
// });

// $(function() {
// 	fancyboxModule.init();
// });

$(window).on("load", function () {
	equalize();
});